"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeTagsFromSwaggerDocument = exports.buildPublicSwaggerDocument = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const intersection_1 = __importDefault(require("lodash/intersection"));
const internalTags = ['internal'];
// Nest doesn't filter API endpoints by tag; we have to implement this behavior ourselves.
// Example from https://github.com/nestjs/swagger/issues/1002
// I am not sure how to exclude "orphaned" DTOs involved in the private/internal endpoints.
const buildPublicSwaggerDocument = (document) => {
    const paths = {};
    const docClone = (0, cloneDeep_1.default)(document);
    for (const path of Object.keys(document.paths)) {
        const pathMethods = {};
        for (const method of Object.keys(document.paths[path])) {
            const endpointTags = docClone.paths[path][method].tags;
            if (endpointTags?.length &&
                (0, intersection_1.default)(internalTags, endpointTags).length) {
                // skip this endpoint
                continue;
            }
            pathMethods[method] = docClone.paths[path][method];
        }
        if (Object.keys(pathMethods).length) {
            paths[path] = pathMethods;
        }
    }
    return {
        ...docClone,
        paths,
    };
};
exports.buildPublicSwaggerDocument = buildPublicSwaggerDocument;
const removeTagsFromSwaggerDocument = (document) => {
    const docClone = (0, cloneDeep_1.default)(document);
    for (const path of Object.keys(docClone.paths)) {
        for (const method of Object.keys(docClone.paths[path])) {
            delete docClone.paths[path][method].tags;
        }
    }
    return docClone;
};
exports.removeTagsFromSwaggerDocument = removeTagsFromSwaggerDocument;
//# sourceMappingURL=swagger.js.map